import FormBase from "../FormBase";
import FormFieldBase from "../../forms/FormFieldBase";
import ValidationBase, { ValidationType } from "../../forms/ValidationBase";
import PhysicianRecommendationService from "../../services/PhysicianRecommendationService";
import Professional from '../../models/Professional'
export class PhysicianRecommendationDataFormItem {

    Id: number;
    Name: string;
    CRM: string;
    Email: string;
    Specialty: string;
    SpecialtyValue: any;

    constructor(Id: number, Name: string, CRM: string, Email: string, Specialty: any) {
        this.Id = Id;
        this.Name = Name;
        this.CRM = CRM;
        this.Email = Email;
        this.Specialty = Specialty.Text;
        this.SpecialtyValue = Specialty;
    }


    static NewInstance(): PhysicianRecommendationDataFormItem {
        return new PhysicianRecommendationDataFormItem(0, "", "", "", "");
    }
}

export default class PhysicianRecommendationDataForm implements FormBase {

    Name: FormFieldBase;
    CRM: FormFieldBase;
    Email: FormFieldBase;
    Specialty: FormFieldBase;
    PhysicianRecommendationDataFormItemList: PhysicianRecommendationDataFormItem[];
    PhysicianRecommendationDataFormItemToEdit: PhysicianRecommendationDataFormItem;


    constructor(Name: string, CRM: string, Email: string, Specialty: string) {
        this.Name = new FormFieldBase(Name, [new ValidationBase("", ValidationType.OBRIGATORIO)]);
        this.CRM = new FormFieldBase(CRM, [new ValidationBase("", ValidationType.CRM)]);
        this.Email = new FormFieldBase(Email, [new ValidationBase("", ValidationType.OBRIGATORIO), new ValidationBase("", ValidationType.EMAIL)]);
        this.Specialty = new FormFieldBase(Specialty, [new ValidationBase("", ValidationType.OBRIGATORIO)]);
        this.PhysicianRecommendationDataFormItemList = new Array<PhysicianRecommendationDataFormItem>();
        this.PhysicianRecommendationDataFormItemToEdit = PhysicianRecommendationDataFormItem.NewInstance();
    }


    static NewInstance(): PhysicianRecommendationDataForm {
        return new PhysicianRecommendationDataForm("", "", "", "");
    }


    ValidateForm(): boolean {
        let propNames = Object.getOwnPropertyNames(this);

        let formIsValid = true;

        for (let index = 0; index < propNames.length; index++) {
            const element = propNames[index];
            const error = this.GetFieldByName(element).ValidateField();

            if (error  !== null && error  !== "") {
                formIsValid = false;
            }
        }

        return formIsValid;
    }


    ValidateToGoNextStep(): string {
        if (this.PhysicianRecommendationDataFormItemList.length  !== 5) {
            return "Por favor, insira 5(cinco) médicos indicados para referência.";
        }
        return "";
    }


    GetFieldByName(name: string): FormFieldBase {
        switch (name) {
            case "Name":
                return this.Name;
            case "CRM":
                return this.CRM;
            case "Email":
                return this.Email;
            case "Specialty":
                return this.Specialty;
            default:
                return new FormFieldBase("", []);
        }
    }

    CallInsertOrUpdateApi(Professional: Professional): Promise<any> {
        const dataJson = this.getJsonObjet();
        return PhysicianRecommendationService.postInsertOrUpdatePhysicianRecommendation(dataJson, Professional.Id);
    }
    

    AddOrUpdatePhysicianRecommendationDataFormItem() {
        if (this.ValidateForm()) {
            if (this.PhysicianRecommendationDataFormItemToEdit === null || this.PhysicianRecommendationDataFormItemToEdit.Id === 0) {

                if (this.PhysicianRecommendationDataFormItemList.length < 5) {
                    let physicianRecommendation = new PhysicianRecommendationDataFormItem(
                        this.getNewId(),
                        this.Name.Value,
                        this.CRM.Value,
                        this.Email.Value,
                        this.Specialty.Value
                    )
                    this.PhysicianRecommendationDataFormItemList.push(physicianRecommendation);
                }
            } else {

                for (let index = 0; index < this.PhysicianRecommendationDataFormItemList.length; index++) {
                    const element = this.PhysicianRecommendationDataFormItemList[index];
                    if (element.Id === this.PhysicianRecommendationDataFormItemToEdit.Id) {

                        let physicianRecommendation = new PhysicianRecommendationDataFormItem(
                            element.Id,
                            this.Name.Value,
                            this.CRM.Value,
                            this.Email.Value,
                            this.Specialty.Value
                        )
                        this.PhysicianRecommendationDataFormItemList[index] = physicianRecommendation;
                    }
                }
            }
            this.ResetForm();
        }
    }


    EditPhysicianRecommendationDataFormItem(id: number) {
        this.ResetForm();
        
        for (let index = 0; index < this.PhysicianRecommendationDataFormItemList.length; index++) {
            const element = this.PhysicianRecommendationDataFormItemList[index];

            if (element.Id === id) {
                this.PhysicianRecommendationDataFormItemToEdit = element;
                this.Name.Value = this.PhysicianRecommendationDataFormItemToEdit.Name;
                this.CRM.Value = this.PhysicianRecommendationDataFormItemToEdit.CRM;
                this.Email.Value = this.PhysicianRecommendationDataFormItemToEdit.Email;
                this.Specialty.Value = this.PhysicianRecommendationDataFormItemToEdit.SpecialtyValue;
            }
        }
    }


    RemovePhysicianRecommendationDataFormItem(id: number) {
        for (let index = 0; index < this.PhysicianRecommendationDataFormItemList.length; index++) {
            const element = this.PhysicianRecommendationDataFormItemList[index];
            if (element.Id === id) {
                this.PhysicianRecommendationDataFormItemList.splice(index, 1);
            }
        }
    }


    ResetForm(): void {
        let propNames = Object.getOwnPropertyNames(this);
        for (let index = 0; index < propNames.length; index++) {
            const element = propNames[index];
            this.GetFieldByName(element).Value = "";
            this.GetFieldByName(element).Error = "";
        }

        this.PhysicianRecommendationDataFormItemToEdit = PhysicianRecommendationDataFormItem.NewInstance();
    }


    getNewId(): number {
        if (this.PhysicianRecommendationDataFormItemList.length > 0) {
            let maxId = Math.max.apply(Math, this.PhysicianRecommendationDataFormItemList.map(function (o) { return o.Id; }))
            return maxId + 1;
        } else {
            return 1;
        }
    }

    getJsonObjet() {

        let viewModelList: any[] = [];

        if (this.PhysicianRecommendationDataFormItemList != null && this.PhysicianRecommendationDataFormItemList.length > 0) {
            this.PhysicianRecommendationDataFormItemList.forEach((element: PhysicianRecommendationDataFormItem) => {
                viewModelList.push({
                    "crm": element.CRM,
                    "name": element.Name,
                    "email": element.Email,
                    "specialty": element.SpecialtyValue.Id
                  })
            });
        }

        return viewModelList;
    }
}   